import React from "react";
import LandingHero from "./landingpage/LandingHero";
import LandingSocials from "./landingpage/LandingSocials";
import LandingBonuses from "./landingpage/LandingBonuses";
import LandingLeaderboards from "./landingpage/LandingLeaderboards";


const RewardsIndex = () => {

    return (
        <div className={"fadeIn landingPage"}>
            <LandingBonuses />
            <LandingLeaderboards />
        </div>
    );
}

export default RewardsIndex;